export default "__VITE_ASSET__BVSHFIqf__"